import React, { useEffect, useState } from 'react';
import { isNullOrUndefined } from 'utils/Global';

type TableInputProps = {
  initialValue: string;
  changeInputValue?: (e: string) => void;
  disabled?: boolean;
  type?: string;
  step?: number;
  onBlurInput?: (e) => void;
  customStyle?: any;
  readOnly?: boolean;
  onClick?: (val) => void;
  className?: string;
  maxValue?: number;
};

function TableInput({
  initialValue,
  changeInputValue,
  disabled = false,
  type = 'number',
  onBlurInput,
  customStyle = null,
  readOnly = false,
  onClick,
  className,
  step,
  maxValue,
}: TableInputProps) {
  const [value, setValue] = useState(initialValue);
  function onChange(e) {
    const val = e.target.value;
    if (maxValue && parseFloat(val) > maxValue) {
      return;
    }
    setValue(val);
    changeInputValue(val);
  }
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  if (type === 'text' || type === 'number') {
    return (
      <input
        id="tableinput-input"
        data-testid="tableinput-input"
        style={{ maxWidth: '100%', ...customStyle }}
        className={className}
        type={type}
        step={step || 1}
        value={value}
        onChange={!isNullOrUndefined(onChange) && onChange}
        disabled={disabled}
        onBlur={() => !isNullOrUndefined(onBlurInput) && onBlurInput(value)}
        readOnly={readOnly}
        {...(onClick && { onClick })}
      />
    );
  } else {
    return (
      <textarea
        id="tableinput-textarea"
        data-testid="tableinput-textarea"
        style={{ maxWidth: '100%', resize: 'none' }}
        value={value}
        onChange={onChange}
        disabled={disabled}
        cols={40}
        onBlur={onBlurInput}
      />
    );
  }
}

export default TableInput;
